import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-tokens',
  templateUrl: './input-tokens.component.html',
  styleUrls: ['./input-tokens.component.scss']
})
export class InputTokensComponent implements OnInit {

  @Input() chips: string[] | object[];
  @Output() chipsChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() canRemove: boolean = true;
  @Input() bindLabel: string = 'name';
  @Input() placeholder: string ;
  @Input() limit: number;
  constructor() { }

  ngOnInit(): void {
  }

  removeChip(i: number){
    this.chips.splice(i,1);
    this.chipsChange.emit(this.chips);
  }
}
